import type { VideoKind } from '../types.ts';

const LABELS: Record<VideoKind, string> = {
  edited: '편집',
  replay: '다시보기',
  shorts: '쇼츠',
};

export function KindBadge({ kind }: { kind: VideoKind }) {
  return (
    <span className={`ss-kind ss-kind--${kind}`}>
      <span className="ss-kind__dot" />
      {LABELS[kind]}
    </span>
  );
}
